import { isMobileContextKind } from '@gonfalon/contexts/kinds/isMobileContextKind';

import type { Clause } from './types';

export function isMobileClause(clause: Clause) {
  if (clause.contextKind) {
    return isMobileContextKind(clause.contextKind);
  }
  return false;
}
